/* tslint:disable */
/* eslint-disable */
/* @relayHash 400223cd0f5cd70ad99fb8cbb5d153e9 */

import { ConcreteRequest } from "relay-runtime";
export type UserAddAddressInput = {
    userId: string;
    validateBuyerShipping?: boolean | null;
    address: AddressInput;
    mockAddressBook?: boolean | null;
    clientMutationId?: string | null;
};
export type AddressInput = {
    active?: boolean | null;
    addressBookMember?: boolean | null;
    contact?: string | null;
    city?: string | null;
    company?: string | null;
    country?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    label?: string | null;
    line1?: string | null;
    line2?: string | null;
    phoneNumber?: string | null;
    state?: string | null;
    zipCode?: string | null;
};
export type dblUserAddAddressMutationVariables = {
    input: UserAddAddressInput;
};
export type dblUserAddAddressMutationResponse = {
    readonly userAddAddress: {
        readonly address: {
            readonly serviceId: string | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
        } | null;
    } | null;
};
export type dblUserAddAddressMutation = {
    readonly response: dblUserAddAddressMutationResponse;
    readonly variables: dblUserAddAddressMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dblUserAddAddressMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserAddAddressPayload",
        "kind": "LinkedField",
        "name": "userAddAddress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dblUserAddAddressMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserAddAddressPayload",
        "kind": "LinkedField",
        "name": "userAddAddress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/326.0.0-2021-08-04T21:25:51.476Z/dblUserAddAddressMutation",
    "metadata": {},
    "name": "dblUserAddAddressMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '07798d83253ef0d6fb8af14aff716c81';
export default node;
